import React, { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Disclaimer } from "@/components/Disclaimer";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "Your inner world is yours. This policy explains, in plain language, how TheInner.app handles your data.",
    sections: [
      ["Your data belongs to you", "Your assessment answers, profile, journal entries, and coaching conversations are stored to power your reports and AI Coach. You can export or permanently delete all of it at any time from your settings."],
      ["What we collect", "Your email, name, assessment responses, and any content you create inside TheInner.app (journal entries, coaching messages). We do not sell your data."],
      ["How your data is used", "Solely to generate your reports, maintain your evolving profile, and personalize your AI Coach. Anonymized, aggregate patterns may inform product improvements."],
      ["Third parties", "We use trusted infrastructure providers for hosting, AI generation, and authentication. They process data only to deliver these services."],
      ["Deletion", "Use 'Delete my data' in Settings to permanently remove your profile, reports, journal, and coaching history."],
    ],
  },
  terms: {
    title: "Terms of Service",
    intro: "By using TheInner.app you agree to these terms.",
    sections: [
      ["Educational purpose only", "TheInner.app is an educational and self-reflection tool. It is not therapy, medical advice, diagnosis, or a substitute for professional mental health care."],
      ["Acceptable use", "You agree to use TheInner.app for personal growth and reflection, and not to misuse the platform or its AI features."],
      ["Accounts", "You are responsible for keeping your account credentials secure. Reports and profiles are tied to your account."],
      ["No guarantees", "Insights are generated from psychological frameworks and your responses. They are interpretive, not clinical, and outcomes vary by individual."],
      ["Changes", "We may update these terms as the platform evolves. Continued use constitutes acceptance."],
    ],
  },
  disclaimer: {
    title: "Psychological Disclaimer",
    intro: "Please read this carefully before engaging with any assessment or coaching feature.",
    sections: [
      ["Not a clinical tool", "TheInner.app is an educational and self-reflection tool. It is not therapy, medical advice, or a substitute for professional mental health care."],
      ["If you are struggling", "If you are in crisis, experiencing severe distress, or having thoughts of harming yourself, please contact a licensed professional or a crisis line in your country immediately."],
      ["Interpretive, not diagnostic", "Archetypes, scores, and reports are interpretive frameworks for reflection — not diagnoses. They describe patterns, not pathology."],
      ["Use alongside professional support", "TheInner.app works best as a companion to, not a replacement for, professional care and your own discernment."],
    ],
  },
};

export function Legal({ page }) {
  const c = CONTENT[page] || CONTENT.disclaimer;
  useEffect(() => window.scrollTo(0, 0), [page]);
  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <div className="mx-auto max-w-3xl px-5 pb-24 pt-32 sm:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-500">Legal</p>
        <h1 className="mt-4 font-heading text-4xl font-light tracking-tight text-slate-50">{c.title}</h1>
        <p className="mt-4 text-base leading-relaxed text-slate-400">{c.intro}</p>
        <div className="mt-10 space-y-8">
          {c.sections.map(([h, body], i) => (
            <div key={i}>
              <h2 className="font-heading text-xl font-medium text-slate-100">{h}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{body}</p>
            </div>
          ))}
        </div>
        <div className="mt-12">
          <Disclaimer />
        </div>
      </div>
      <Footer />
    </div>
  );
}
